import {BreadcrumbManager as HeadlessBreadcrumbManager} from '@coveo/headless';
import {useEffect, useState, FunctionComponent} from 'react';
import React from 'react';

interface BreadcrumbManagerProps {
  controller: HeadlessBreadcrumbManager;
}

export const BreadcrumbManager: FunctionComponent<BreadcrumbManagerProps> = (
  props
) => {
  const {controller} = props;
  const [state, setState] = useState(controller.state);

  useEffect(() => controller.subscribe(() => setState(controller.state)), []);

  if ( ! state?.hasBreadcrumbs ) {
    return null;
  }

  return (
    <ul className="coveo-advanced-query__active-filters wp-block-buttons">
      { state.facetBreadcrumbs.map( ( facet ) => (
        facet.values.map( ( breadcrumb ) => (
          <li
            key={ breadcrumb.value.value }
            className="coveo-advanced-query__active-filter wp-block-button is-style-plain-text"
          >
            <button
              key={ breadcrumb.value.value }
              onClick={ () => breadcrumb.deselect() }
              className="wp-block-button__link wp-element-button button--small"
            >
              <svg
                className="svg svg--svg-assets-svg-icon-close"
                role="img"
                focusable="false"
                height="24"
                width="24"
              >
                <use xlinkHref="#svg-assets-svg-icon-close" />
              </svg>
              <span>
                { facet.field }: { breadcrumb.value.value }
              </span>
            </button>
          </li>
        ) )
      ) ) }
    </ul>
  );
};

// usage

/**
 * ```tsx
 * const controller = buildBreadcrumbManager(engine);
 *
 * <BreadcrumbManager controller={controller} />;
 * ```
 */
